import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './config';

export const createProblem = async (problemData) => {
  const docRef = await addDoc(collection(db, 'problems'), {
    ...problemData,
    likes: 0,
    comments: 0,
    isHighlit: false,
    createdAt: serverTimestamp(),
  });

  return docRef;
};